export default __webpack_public_path__ + "static/media/ic_non_cart.d208bb0c.svg";